import { TimeoutService } from '@df/ng/timeout.service';
import { Injectable, inject } from '@angular/core';
import { GtmDlService } from '@df/module-gtm/service/gtm-dl.service';
import './gtm-event-convert-experiments';
import { AbService } from '@df/module-ab/ab.service';
import { IGtmEventConvertExperiment } from './gtm-event-convert-experiments';
import { App } from '@df/core/app';

@Injectable({
    providedIn: 'root'
})
export class GtmEventConvertExperimentsTrigger {
    private lastState?: string;

    private readonly gtmService = inject(GtmDlService);
    private readonly abService = inject(AbService);
    private readonly timeoutService = inject(TimeoutService);
    private readonly app = inject(App);

    private readonly onExperimentsChange = this.timeoutService.debounce(() => {
        const experiments = this.getExperiments();
        if (experiments?.length) {
            this.dispatch(experiments);
        }
    }, 500);

    constructor() {
        if (this.app.isPlatformBrowser) {
            this.abService.onReady(() => {
                this.init();
            });
        }
    }

    private init() {
        this.abService.change$.subscribe(() => {
            this.onExperimentsChange();
        });
        this.onExperimentsChange();
    }

    private getExperiments(): IGtmEventConvertExperiment[] {
        const experiments = this.abService.retrieveConvertExperiments() || [];
        return experiments
            .map(i => {
                const variantId = i.variantId;
                if (variantId && i.variants && i.experimentName) {
                    const variant = i.variants[variantId];
                    if (variant) {
                        return {
                            exp_name: i.experimentName,
                            exp_variant: variant.name
                        };
                    }
                }
                return undefined;
            })
            .filter(i => !!i);
    }

    private async dispatch(experiments: IGtmEventConvertExperiment[]) {
        const state = JSON.stringify(experiments);
        if (this.lastState === state) {
            return;
        }
        this.lastState = state;
        return this.gtmService.dispatch({
            event: 'convert_experiments',
            experiment_data: experiments
        });
    }
}
